export function getTrafficTrackUrl() {
  const config = useRuntimeConfig()
  return `${config.public.apiBase}/v1/track-traffic`
}
